import { NavigationGuard } from "vue-router";
import { cancelRequestStore } from "@/store/cancel-request";

/**
 * キャンセル申請を完了したか
 * @param to
 * @param _from
 * @param next
 */
export const completedCancelRequest: NavigationGuard = (to, _from, next) => {
  const { phoneCallApplicationId, cancelType } = cancelRequestStore;
  // 電話連絡が必要な場合、電話連絡画面に強制的に遷移させる
  if (
    phoneCallApplicationId !== null &&
    !new RegExp(`^/applications/cancel/${phoneCallApplicationId}`).test(to.path)
  ) {
    next({
      name: "ApplicationCancel",
      params: { applicationId: phoneCallApplicationId.toString() },
      query: { cancelType: cancelType ? cancelType : undefined }
    });
    return;
  }
  next();
};
